import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import DataTable from '../components/DataTable';
import { fetchEducatorDomains } from '../services/api';

const EducatorDomains = () => {
    const [educatorData, setEducatorData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadEducatorData = async () => {
            try {
                setLoading(true);
                const response = await fetchEducatorDomains();
                // Sort by user_number descending (highest first)
                const sortedData = [...response].sort((a, b) => b.user_number - a.user_number);
                setEducatorData(sortedData);
            } catch (err) {
                console.error('Error loading educator domains data:', err);
                setError('Failed to load educator domains data');
            } finally {
                setLoading(false);
            }
        };

        loadEducatorData();
    }, []);

    // Define table columns
    const columns = [
        {
            key: 'domain',
            label: 'Email Domain',
            type: 'text'
        },
        {
            key: 'user_number',
            label: '# of Educators Active in 2025+',
            type: 'number'
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50">
            <Header pageTitle="# of Domains with 2+ Educators active in 2025+" />
            
            <div className="px-6 py-6">
                {loading ? (
                    <div className="bg-white rounded-lg shadow p-6 flex justify-center items-center h-64">
                        <div className="text-lg text-gray-600">Loading educator domains...</div>
                    </div>
                ) : error ? (
                    <div className="bg-white rounded-lg shadow p-6 flex justify-center items-center h-64">
                        <div className="text-lg text-red-600">Error: {error}</div>
                    </div>
                ) : (
                    <DataTable
                        data={educatorData}
                        columns={columns}
                        title=""
                        rowsPerPage={100}
                        showVisualBars={true}
                    />
                )}
            </div>
        </div>
    );
};

export default EducatorDomains;